'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useTranslations } from 'next-intl';
import { BasicImage } from '@/components/page-builder/components/BasicImage';
import { Switch } from '@/components/ui/switch';
import { MONTHLY_VISIBLE_PLANS } from '@/constants/pricing.constants';
import { formatEventName, useAnalytics } from '@/lib/analytics/analytics';
import { ANALYTICS_EVENTS } from '@/lib/analytics/analytics.constants';
import { cn } from '@/lib/styles';
import { PRICING_TEST_IDS } from '@/lib/test-ids';
export function BillingSwitch(t0) {
  const $ = _c(51);
  const {
    data,
    yearly,
    setYearly,
    currentTab,
    setCurrentTab,
    tagImage,
    arrowImage
  } = t0;
  const t = useTranslations("Pricing");
  const {
    track
  } = useAnalytics();
  let t1;
  if ($[0] !== currentTab || $[1] !== data || $[2] !== setCurrentTab || $[3] !== setYearly || $[4] !== track || $[5] !== yearly) {
    t1 = function handleCheckedChange(checked) {
      const fromBilling = yearly ? "yearly" : "monthly";
      const toBilling = checked ? "yearly" : "monthly";
      track({
        eventType: formatEventName(ANALYTICS_EVENTS.PRICING_BILLING_TOGGLED),
        eventProperties: {
          fromCycle: fromBilling,
          toCycle: toBilling
        }
      });
      setYearly?.(checked);
      const allPlans = data ?? [];
      const visiblePlans = checked ? allPlans : allPlans.slice(0, MONTHLY_VISIBLE_PLANS);
      if (!visiblePlans.some(plan => plan?.title === currentTab)) {
        setCurrentTab(visiblePlans[0]?.title ?? "");
      }
    };
    $[0] = currentTab;
    $[1] = data;
    $[2] = setCurrentTab;
    $[3] = setYearly;
    $[4] = track;
    $[5] = yearly;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleCheckedChange = t1;
  const t2 = !yearly && tagImage ? "lg:justify-between" : "lg:justify-start";
  let t3;
  if ($[7] !== t2) {
    t3 = cn("relative flex justify-center lg:justify-start items-center", t2);
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("billedMonthly");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = !yearly ? "lok-text-body-bold-medium text-neutral-light-100" : "lok-text-body-regular-medium text-neutral-400";
  let t6;
  if ($[11] !== t5) {
    t6 = cn("relative inline-block align-middle", "after:content-[attr(data-text)] after:block after:h-0 after:overflow-hidden after:invisible after:select-none after:pointer-events-none after:font-bold", t5);
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("billedMonthly");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
    t8 = <span data-text={t4} className={t6}>{t7}</span>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = !!yearly;
  let t10;
  if ($[19] !== t || $[20] !== yearly) {
    t10 = yearly ? t("billedYearly") : t("billedMonthly");
    $[19] = t;
    $[20] = yearly;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== handleCheckedChange || $[23] !== t10 || $[24] !== t9) {
    t11 = <Switch className="data-[state=checked]:bg-brand-salmon" onCheckedChange={handleCheckedChange} checked={t9} data-billing-period={t10} />;
    $[22] = handleCheckedChange;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t("billedYearly");
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = yearly ? "lok-text-body-bold-medium text-neutral-light-100" : "lok-text-body-regular-medium text-neutral-400";
  let t14;
  if ($[28] !== t13) {
    t14 = cn("relative inline-block align-middle", "after:content-[attr(data-text)] after:block after:h-0 after:overflow-hidden after:invisible after:select-none after:pointer-events-none after:font-bold", t13);
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t("billedYearly");
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t12 || $[33] !== t14 || $[34] !== t15) {
    t16 = <span data-text={t12} className={t14}>{t15}</span>;
    $[32] = t12;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t11 || $[37] !== t16 || $[38] !== t8) {
    t17 = <div className="flex items-center space-x-2">{t8}{t11}{t16}</div>;
    $[36] = t11;
    $[37] = t16;
    $[38] = t8;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== tagImage || $[41] !== yearly) {
    t18 = !yearly && tagImage ? <div className="hidden lg:block relative w-98 h-8.75"><BasicImage fill={true} component={tagImage} className="object-contain" /></div> : null;
    $[40] = tagImage;
    $[41] = yearly;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== arrowImage || $[44] !== yearly) {
    t19 = !yearly && arrowImage ? <div className="hidden lg:block absolute top-5 right-10 z-10"><div className="relative w-55.75 h-55"><BasicImage fill={true} component={arrowImage} className="object-contain" /></div></div> : null;
    $[43] = arrowImage;
    $[44] = yearly;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t17 || $[47] !== t18 || $[48] !== t19 || $[49] !== t3) {
    t20 = <div className={t3} data-test-id={PRICING_TEST_IDS.YEARLY_SWITCH}>{t17}{t18}{t19}</div>;
    $[46] = t17;
    $[47] = t18;
    $[48] = t19;
    $[49] = t3;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  return t20;
}